export const LOGO_NAMES = {
  AFTERPAY: 'Afterpay',
  CLEARPAY: 'Clearpay',
} as const
export type LogoNames = (typeof LOGO_NAMES)[keyof typeof LOGO_NAMES]

export const THEMED_LOGO_NAMES = {
  CASHAPP_AFTERPAY: 'AfterpayByCashapp',
  ARCADE_AFTERPAY: 'ArcadeAfterpay',
  ARCADE_AFTERPAY_PILL: 'ArcadeAfterpayPill',
  ARCADE_CLEARPAY_PILL: 'ArcadeClearpayPill',
} as const
export type ThemedLogoNames = (typeof THEMED_LOGO_NAMES)[keyof typeof THEMED_LOGO_NAMES]

export const BRANDS = {
  AFTERPAY: 'Afterpay',
  CASHAPP_AFTERPAY: 'CashAppAfterpay',
  CLEARPAY: 'Clearpay',
  ARCADE_AFTERPAY_PILL: 'ArcadeAfterpayPill',
  ARCADE_CLEARPAY_PILL: 'ArcadeClearpayPill',
} as const
export type Brand = (typeof BRANDS)[keyof typeof BRANDS]

export const BRAND_TO_LOGO_MAP: Record<Brand, LogoNames | ThemedLogoNames> = {
  [BRANDS.AFTERPAY]: LOGO_NAMES.AFTERPAY,
  [BRANDS.CASHAPP_AFTERPAY]: THEMED_LOGO_NAMES.CASHAPP_AFTERPAY,
  [BRANDS.CLEARPAY]: LOGO_NAMES.CLEARPAY,
  [BRANDS.ARCADE_AFTERPAY_PILL]: THEMED_LOGO_NAMES.ARCADE_AFTERPAY_PILL,
  [BRANDS.ARCADE_CLEARPAY_PILL]: THEMED_LOGO_NAMES.ARCADE_CLEARPAY_PILL,
}

export const COLORS = {
  DEFAULT: 'Black',
} as const

export const COLORS_MAP = {
  [COLORS.DEFAULT]: '#000',
}

export const SIZES = {
  SMALL: 'Small',
  MEDIUM: 'Medium',
  LARGE: 'Large',
  XLARGE: 'XLarge',
} as const

export const ROLES = {
  IMAGE: 'img',
} as const
